<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    {{ $t("billing_mapping_role_access") }}
                  </h4>
                  <button
                    v-if="permision_role.method_create"
                    class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="createData()">
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>

                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()">
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                </div>

                <div class="card-body">
                  <vue-good-table
                    ref="list-billing"
                    :rows="rows"
                    :columns="columns"
                    :totalRows="totalRecords"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000],
                    }"
                    :isLoading.sync="isLoading"
                    :select-options="{
                      enabled: true,
                      selectOnCheckboxOnly: true,
                      selectionText: $t('data_selected'),
                      clearSelectionText: $t('clear'),
                    }"
                    @on-selected-rows-change="selectionChanged"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange">
                    <!-- Table Actions -->
                    <div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>

                    <!-- Selected Row Actions -->
                    <div slot="selected-row-actions">
                      <button
                        class="btn btn-danger btn-xs"
                        style="margin-right: 20px"
                        @click="deleteMass">
                        <i class="mdi mdi-delete"></i> {{ $t("DeleteTxt") }}
                      </button>
                    </div>

                    <!-- Row Template -->
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'" class="action-cell">
                        <!-- Ikon Edit -->
                        <a
                          href="#"
                          title="Edit"
                          @click.prevent="editData(props.index, props.row)">
                          <i
                            class="mdi mdi-square-edit-outline h4 text-success"></i>
                        </a>

                        <!-- Ikon View -->
                        <a
                          href="#"
                          title="Detail"
                          @click.prevent="detailData(props.index, props.row)">
                          <i class="mdi mdi-eye h4"></i>
                        </a>
                      </span>
                      <span v-else-if="props.column.field === 'datas'">
                        <span v-html="formatDatas(props.row.datas)"></span>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "RoleAccessIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      mapping_ids: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("action_txt"),
          field: "actions",
          width: "80px",
          sortable: false,
          thClass: "text-center",
        },
        {
          label: this.$t("mapping_id"),
          field: "mapping_id",
          width: "120px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("mapping_id"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("role_name"),
          field: "role_name",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("role_name"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("access_to"),
          field: "datas",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("access_to"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rows: [],
      rowsSelection: [],
      mapping_id_selections: [],
    };
  },
  computed: {
    isAllSelected() {
      return (
        this.mapping_ids.length === this.rows.length && this.rows.length > 0
      );
    },
  },
  watch: {},
  methods: {

    formatDatas(data) {
      if (!data) return "No data available"; // Penanganan jika data kosong

      try {
        // Parsing JSON string menjadi objek
        const parsedData = JSON.parse(data);

        // Memeriksa apakah properti `warehouse` ada
        if (parsedData.warehouse) {
          // Gabungkan warehouseId dan warehouseName
          let result = parsedData.warehouse
            .map((item) => `${item.warehouseId} - ${item.warehouseName}`)
            .join(" & "); // Menggabungkan dengan '&' biasa

          // Mengganti karakter '&' dengan <span> yang di-style untuk warna merah
          result = result.replace(/&/g, '<span style="color: red;">&</span>');

          return `<span style="color: red;">warehouse : </span>${result}`;
        }
      } catch (error) {
        console.error("Error parsing datas field:", error);
        return "Invalid data format"; // Penanganan error parsing
      }

      return "No data available"; // Jika tidak ada warehouse
    },

    deleteMass() {
      if (this.mapping_id_selections.length === 0) {
        this.$swal({
          icon: "warning",
          title: this.$t("no_select_data"),
        });
        return;
      }

      console.log("Selected IDs:", this.mapping_id_selections); // Debugging untuk memastikan ID terpilih

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;

          const formData = {
            mapping_ids: this.mapping_id_selections, // Pastikan ini berisi array ID
          };

          const baseURI =
            this.$settings.endPointBilling +
            "mapping/role-user-billing/delete-mass";

          this.$http
            .delete(baseURI, { data: formData, timeout: 10000 })
            .then((response) => {
              this.isLoading = false;

              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.mapping_id_selections = []; // Reset setelah berhasil
                this.loadItems(); // Refresh data
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.isLoading = false;
              if (error.code === "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else if (error.response) {
                this.resultError(error.response.data.errors);
              }
            });
        }
      });
    },

    createData() {
      window.location.href = "/billing-mapping/role-access/create";
    },

    editData(index, row) {
      var params = this.$onRandom(row.mapping_id);
      window.location.href = "/billing-mapping/role-access/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.mapping_id);
      window.location.href = "/billing-mapping/role-access/detail/" + params;
    },

    loadItems() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointBilling + "mapping/role-user-billing";

      return this.$http
        .get(
          baseURI +
            `?datas=${this.serverParams.columnFilters.datas}&role_name=${this.serverParams.columnFilters.role_name}&mapping_id=${this.serverParams.columnFilters.mapping_id}&limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    downloadData() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointBilling + "mapping/role-user-billing";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
            `?datas=${this.serverParams.columnFilters.datas}&role_name=${this.serverParams.columnFilters.role_name}&mapping_id=${this.serverParams.columnFilters.mapping_id}&limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    selectionChanged(ev) {
      this.rowsSelection = [];
      this.mapping_id = [];
      this.rowsSelection = ev.selectedRows;
      this.mapping_id_selections = ev.selectedRows.map((row) => row.mapping_id);

      this.rowsSelection.forEach((item) => {
        this.mapping_id.push(item.mapping_id);
      });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterWarehouseCmlController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadItems();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}

.action-cell {
  display: flex;
  align-items: center;
  gap: 10px; /* Jarak antar elemen */
}

.custom-checkbox {
  width: 20px; /* Ukuran checkbox */
  height: 20px;
  cursor: pointer;
  margin: 0 auto; /* Pusatkan di kolom */
}

.custom-icon {
  font-size: 24px; /* Ukuran ikon */
}
</style>
